import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#464646",
      "clip-path": "url(#clip0_3342_22168)"
    }, [
      _createElementVNode("path", { d: "M0 19.134c0 .487.332.866.717.866h18.557c.394 0 .726-.379.726-.866 0-.477-.332-.867-.726-.867H.717c-.385 0-.717.39-.717.867M15.41 15.517c0 .607.314.964.834.964h2.07c.512 0 .834-.358.834-.964V8.36c0-.607-.322-.975-.833-.975h-2.071c-.52 0-.834.368-.834.975zM10.551 15.517c0 .606.323.964.834.964h2.07c.52 0 .844-.358.844-.964V3.433c0-.607-.323-.964-.843-.964h-2.071c-.511 0-.834.357-.834.964zM5.701 15.517c0 .606.314.964.825.964h2.08c.511 0 .834-.358.834-.964V.964C9.44.357 9.117 0 8.606 0h-2.08c-.51 0-.825.357-.825.964zM.843 15.517c0 .607.322.964.833.964h2.071c.52 0 .843-.358.843-.964V5.934c0-.596-.323-.964-.843-.964h-2.07c-.512 0-.834.368-.834.964z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_3342_22168" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v20H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }